class ProductStickyBar extends HTMLElement {
    constructor() {
        super();

        this.optionItems = this.querySelectorAll("[js-option-item]");
        this.subscriptionSelects = this.querySelectorAll("[js-subscription-select]");
        this.init();
        document.body.className.includes("discount--") ? this.handlePriceDiscount() : null;
    }

    init() {
        this.optionItems.forEach( optionItem => optionItem.addEventListener("change", function() {
            const container = this.closest("[js-sticky-bar-block]");
            const quickAddBtn = container.querySelector("quick-add-button");
            const atcPriceEl = container.querySelector("[js-atc-price]");
            const subscriptionRegularPriceEl = container.querySelector("[js-subscription-regular-price]");
            const subscriptionComparePriceEl = container.querySelector("[js-subscription-compare-price]");
            const variant_id = this.value;
            const regularPrice = this.getAttribute("data-product-price");
            const subscriptionRegularPrice = this.getAttribute("data-subscription-regular-price");
            const subscriptionComparePrice = this.getAttribute("data-subscription-compare-price");
    
            if(quickAddBtn && variant_id) {
                quickAddBtn.setAttribute("variant-id", variant_id)
            };

            atcPriceEl.textContent = regularPrice;

            if(subscriptionRegularPriceEl && subscriptionComparePriceEl) {
                subscriptionComparePriceEl.textContent = subscriptionComparePrice;
                subscriptionRegularPriceEl.textContent = subscriptionRegularPrice;
            }
        }));

        this.subscriptionSelects.forEach( select => select.addEventListener("change", ({ currentTarget }) => {
            const container = currentTarget.closest("[js-sticky-bar-block]");
            const quickAddBtn = container.querySelector("quick-add-button");
            const selling_plan = currentTarget.value;

            if(quickAddBtn && selling_plan) {
                quickAddBtn.setAttribute("selling-id", selling_plan);
                this.classList.add("is-subscription-enabled");
            }else {
                quickAddBtn.setAttribute("selling-id", "");
                this.classList.remove("is-subscription-enabled");
            }
        }))
    }

    handlePriceDiscount() {
        this.optionItems.forEach( optionItem => {
          optionItem.checked = false;
          const productOption = optionItem.closest(".product__option");
          const regularPrice = parseFloat(optionItem.getAttribute("data-product-price").replace(/[^0-9.]/g, ''));
          let discountRegularPrice;
    
          if(document.body.classList.contains("discount--ten")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.1)).toFixed(2);
          }if(document.body.classList.contains("discount--fifteen")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.15)).toFixed(2);
          }if(document.body.classList.contains("discount--twenty")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.2)).toFixed(2);
          }if(document.body.classList.contains("discount--twenty-five")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.25)).toFixed(2);
          }if(document.body.classList.contains("discount--thirty")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.3)).toFixed(2);
          }if(document.body.classList.contains("discount--thirty-five")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.35)).toFixed(2);
          }if(document.body.classList.contains("discount--fourty")) {
            discountRegularPrice = (regularPrice - (regularPrice * 0.4)).toFixed(2);
          };
    
          optionItem.setAttribute("data-product-price", `$ ${discountRegularPrice}`);
          if(productOption.querySelector("[js-option-item]") === optionItem) {
            optionItem.labels[0]?.click();
          }
        })
    };
}

customElements.define('product-sticky-bar', ProductStickyBar);